// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"208":"c3d66b48","660":"752d9332","760":"38f27a73","774":"5ea5d9db","787":"1fee1fb8","854":"f89ca95b","883":"1efd7367"}[chunkId] + ".chunk.js";
};